<div class="main no-padding">
  <header-menu></header-menu>

<!-- header -->

<div *ngIf="isLoading" class="logo-gif">
  <img src="assets/shared/img/logo_allya.gif">
</div>

<div class="content top-padding" style="position: relative; z-index: 1;">
  <div class="content-wrapper establishment-detail-wrapper">
    <div class="col-md-8">

      <div id="establishment-detail" class="card">
        <div class="card-content">
          <header>
            <div class="establishment-detail-photo" *ngIf="company?.image">
              <img src="{{ company?.image }}" alt="" />
            </div>
            <div class="establishment-detail-info">
              <h2>{{ company?.name }}</h2>
              <p>
                <span *ngIf="company?.addresses?.length > 0">
                  <strong>{{ 'DETAIL.COMPANY.ADDRESS' | translate }}</strong> {{ getAddressAsString(company?.addresses[0]) }}<br />
                  <span *ngIf="company?.addresses[0].telephone">
                    <strong>Telefone</strong> {{ company?.addresses[0].telephone }}<br />
                  </span>
                </span>
                <strong>{{ 'DETAIL.COMPANY.EMPLOYEES_NUMBER' | translate }}</strong> {{ companyAccounts }}
              </p>
            </div>
          </header>
        </div>
        <div class="establishment-detail-description">
          <!-- Company description here -->
        </div>
      </div>

      <h3 *ngIf="company?.addresses?.length">{{ 'DETAIL.COMPANY.LOCATIONS' | translate }}</h3>

      <div id="establishment-detail-location" class="card" *ngIf="company?.addresses?.length">
        <div *ngIf="canDisplayMap()" style="height: 400px; width: 100%;" leaflet
          [leafletOptions]="options"
          [leafletLayers]="markers">
        </div>
        <div *ngIf="!canDisplayMap()" id="establishment-detail-location-map"  style="background: #fff url(../../../assets/shared/img/banners/map.png) no-repeat; background-size: cover">
          <div class="pop-up" *ngIf="company?.addresses?.length > 0">
            <strong>{{ company?.addresses[0].nameUnit }}</strong>
            {{ company?.addresses[0].street }}, {{ company?.addresses[0].number }}
            <button (click)="displayMap()" class="btn-orange-contrast">{{ 'DETAIL.COMPANY.SEE_ON_MAP_BUTTON' | translate }}</button>
          </div>
        </div>
        <button class="btn" (click)="displayAllAddresses()">+ {{ 'DETAIL.COMPANY.SHOW_ALL_UNITS_BUTTON' | translate }}</button>
      </div>

      <ul class="card" *ngIf="canDisplayAllAddresses()">
        <li *ngFor="let address of company?.addresses">
          <strong>{{ address.nameUnit }}</strong><br />
          {{ address.street }}, {{ address.number }}, {{ address.neighborhood }} - {{ address.city }}/{{ address.state }} - {{ address.zipCode }}<br />
          {{ address.phone }}
        </li>
      </ul>
    </div>

    <div class="col-md-4">

      <div class="promotion card-yellow">
        <div class="card-content">
          <header>
            <h2>{{ 'DETAIL.COMPANY.YOUR_OFFER_TITLE' | translate }}</h2>
          </header>
          <div class="description">
            <strong>{{ establishment?.offer?.title }}</strong>
            <br />
            <br />
            <p [innerHTML]="establishment?.offer?.term | safeHtml"></p>
          </div>

          <footer class="text-center">
            <a [routerLink]="['/negocio/proposta']" class="btn btn-white" *ngIf="getUserLevel() === 'master' || getUserLevel() === 'finance'"> {{ 'DETAIL.COMPANY.UPDATE_OFFER_BUTTON' | translate }}</a>
          </footer>
        </div>
      </div>
    </div>

  </div>
</div>
